<template>
    <article class="card">
        <header class="card-header">
            <p class="title">
                {{ transChoice('app.message', 2).titleCase() }}
            </p>

            <a
                v-if="canCreateMessages"
                @click="newMessageThread()"
                class="card-header-icon"
            >Add</a>
        </header>

        <div
            v-if="loading"
            class="content-holder"
        >
            <div
                class="centered loader is-medium"
            ></div>
        </div>

        <div
            v-else
            class="content-holder"
        >
            <div v-if="! isEmpty">
                <article
                    v-for="thread in threads"
                    :key="thread.id"
                    class="media unread"
                >
                    <figure class="media-left">
                        <img :src="thread.user.extra_small_avatar">
                    </figure>

                    <div class="media-content">
                        <div class="content">
                            <a :href="route('messages.show', {id: thread.id})" v-text="thread.subject"></a>
                            <small>
                                {{ moment(thread.created_at).fromNow() }}
                            </small>
                            <br>
                            <small><strong>From:</strong> {{ thread.user.name }}</small>
                        </div>
                    </div>
                </article>
            </div>

            <div class="notification" v-else>
                <p>{{ trans('app.message.none') }}</p>
            </div>
        </div>

        <message-thread-add-form-modal></message-thread-add-form-modal>
    </article>
</template>

<script>
export default {
    props: {
        canCreateMessages: {
            type: Boolean,
            default: false,
        },
    },

    data () {
        return {
            threads: [],
            loading: false,
        };
    },

    listeners: {
        'message-thread-updated' () {
            this.fetchList();
        },
    },

    computed: {
        actionRoute () {
            return this.route(
                'messages.index'
            );
        },

        isEmpty () {
            return _.isEmpty(this.threads);
        },
    },

    methods: {
        newMessageThread () {
            OSPEvent.$emit('open-message-thread-add-modal');
        },

        async fetchList () {
            try {
                this.loading = true;
                let {data} = await axios.get(this.actionRoute);

                this.threads = data.data;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
    },

    created () {
        this.fetchList();
    },
};
</script>

<style>
.panel-block .thumbnail {
  width: 3em;
}
</style>
